<template>
  <div v-if="this.$util._isMobile()" class="download_mb_bg" style="height: 100%; overflow: scroll;">
    <img style="width: 88px; height: 25px;position: absolute; top:20px; left: 20px;z-index: 2;cursor: pointer" src="../../assets/img/head_logo.png" @click="goBack">

    <div style="margin-top: 90px">
      <span style="display: block; font-weight: 500;font-size: 24px;line-height: 48px;text-align: center;color: #FFFFFF;">让财富近在咫尺</span>
      <span style="display: block; font-weight: 500;font-size: 16px;text-align: center;color: #FFFFFF;">你需要的一切都在UPlus 应用程序中</span>
      <img style="width: 299px; height: 178px;margin: 30px auto 0;display: flex; justify-self: center" src="../../assets/img/download/pc_phone_mb.png">

      <div style="display: flex; flex-direction: column; justify-content: space-between; width: 80%; margin: 30px auto 0">
        <div>
          <div style="cursor: pointer; margin-top: 10px" @click="downloadsiOS(1)">
            <img style="display:inline-block;width: 30px;height: 30px;vertical-align: middle" src="../../assets/img/download/ios_btn_icon.png">
            <span style="display:inline-block;font-weight: 500;font-size: 14px;text-align: center;color: rgba(255, 255, 255, 1);vertical-align: middle; margin-left: 12px">iOS 描述文件下载（推荐）</span>
          </div>
<!--          <div style="cursor: pointer; margin-top: 10px" @click="downloadsiOS(2)">-->
<!--            <img style="display:inline-block;width: 30px;height: 30px;vertical-align: middle" src="../../assets/img/download/ios_btn_icon.png">-->
<!--            <span style="display:inline-block;font-weight: 500;font-size: 14px;text-align: center;color: rgba(255, 255, 255, 1);vertical-align: middle; margin-left: 12px">iOS TestFlight下载（推荐）</span>-->
<!--          </div>-->
<!--          <div style="cursor: pointer; margin-top: 10px" @click="downloadsiOS(3)">-->
<!--            <img style="display:inline-block;width: 30px;height: 30px;vertical-align: middle" src="../../assets/img/download/ios_btn_icon.png">-->
<!--            <span style="display:inline-block;font-weight: 500;font-size: 14px;text-align: center;color: rgba(255, 255, 255, 1);vertical-align: middle; margin-left: 12px">iOS 分发下载</span>-->
<!--          </div>-->
<!--          <p style="margin-top: 0px; color: #FF5B5B; font-size: 14px; font-weight: 600">（注：此链接下载App不会自动升级，如需升级请重新下载安装！）</p>-->
        </div>
        <div>
          <div style="cursor: pointer; margin-top: 10px" @click="downloadPlatform">
            <img style="display:inline-block;width: 30px;height: 30px;vertical-align: middle" src="../../assets/img/download/android_btn_icon.png">
            <span style="display:inline-block;font-weight: 500;font-size: 14px;text-align: center;color: rgba(255, 255, 255, 1);vertical-align: middle; margin-left: 12px">Android 下载</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-else class="pc_bg" style="height: 100%; position: relative">
    <img style="width: 150px; height: 41px;position: absolute; top:55px; left: 78px;z-index: 2;cursor: pointer" src="../../assets/img/head_logo.png" @click="goBack">
    <span style="position: absolute; top: 150px; left: 50%; transform: translate(-50%, 0); font-weight: 500;font-size: 40px;line-height: 48px;text-align: center;color: #FFFFFF;">让财富近在咫尺 你需要的一切都在UPlus 应用程序中</span>
    <div class="down_content" style="position: absolute; top: 50%; transform: translate(0, -50%);z-index: 2">
      <span  style="display: block;font-weight: 400;font-size: 32px;line-height: 38px;color: #FFFFFF;">全自动量化交易机器人</span>
      <span style="display: block;font-weight: 400;font-size: 32px;line-height: 38px;color: #FFFFFF;margin-top: 20px">百万加密货币投资者的信赖</span>
      <div style="margin-top: 66px">
        <div style="display: flex; justify-content: space-around">
          <div style="display: inline-block; flex-direction: column; text-align: center; width: 171px;">
            <img style="width: 139px; height: 139px;" src="../../assets/img/home/download/iOS_miaoshu.png">
            <span style="display: block; font-size: 16px; color: #FFFFFF">iOS 描述文件下载</span>
<!--            <span style="color: #FFBB54"> (推荐)</span>-->
          </div>
          <div style="display: inline-block; flex-direction: column; text-align: center; width: 171px;">
            <img style="width: 139px; height: 139px;" src="../../assets/img/home/download/new_platform.png">
            <span style="display: block; font-size: 16px; color: #FFFFFF">Android 分发下载</span>
          </div>
<!--          <div style="display: inline-block; flex-direction: column; text-align: center; width: 171px;">-->
<!--            <img style="width: 139px; height: 139px;" src="../../assets/img/home/download/iOS_testflight.png">-->
<!--            <span style="display: block; font-size: 16px; color: #FFFFFF">iOS beta版<span style="color: #FFBB54"> (推荐)</span></span>-->
<!--          </div>-->
        </div>

        <div style="display: flex; justify-content: space-around; margin-top: 20px">
<!--          <div style="display: inline-block; flex-direction: column; text-align: center; width: 171px;">-->
<!--            <img style="width: 139px; height: 139px;" src="../../assets/img/home/download/new_platform.png">-->
<!--            <span style="display: block; font-size: 16px; color: #FFFFFF">iOS 分发下载<span style="color: #FFBB54; display: block"> (此链接无法自动更新)</span></span>-->
<!--          </div>-->
<!--          <div style="display: inline-block; flex-direction: column; text-align: center; width: 171px;">-->
<!--            <img style="width: 139px; height: 139px;" src="../../assets/img/home/download/new_platform.png">-->
<!--            <span style="display: block; font-size: 16px; color: #FFFFFF">Android 分发下载</span>-->
<!--          </div>-->
        </div>

<!--        <div style="display: inline-block; margin-left: 34px;vertical-align: top">-->
<!--          <div style="background: #EE3EAE; width: 202px; height: 58px;border-radius: 60px; display: flex; align-items: center;cursor: pointer" @click="downloadIos">-->
<!--            <img style="width: 25px;height: 30px;margin-left: 20px" src="../../assets/img/download/ios_icon.png">-->
<!--            <span style="font-weight: 400;font-size: 20px;line-height: 24px;color: #FFFFFF;margin-left: 20px">下载 iOS</span>-->
<!--          </div>-->
<!--          <div style="background: #FFFFFF; width: 202px; height: 58px;border-radius: 60px; display: flex; align-items: center; margin-top: 20px;cursor: pointer" @click="downloadAndroid">-->
<!--            <img style="width: 25px;height: 30px;margin-left: 20px" src="../../assets/img/download/android_icon.png">-->
<!--            <span style="font-weight: 400;font-size: 20px;line-height: 24px;color: #EE3EAE;margin-left: 20px">下载 Android</span>-->
<!--          </div>-->
<!--        </div>-->
<!--        <p style="margin-top: 20px; color: #FF4D4F; text-align: center; font-size: 18px; font-weight: 600">注：苹果手机用户需要翻墙使用！</p>-->
      </div>
    </div>
    <img style="position: absolute; right: 0; width: 50%;top: 55%; transform: translate(0, -40%)" src="../../assets/img/download/pc_phone.png">
  </div>


</template>

<script>
import screenfull from '../../assets/js/screenfull';
import download from '../../utils/registered_address'
export default {
  name: "download_app",
  data() {
    return {
      showBack: 1,
      token: '1',
      language: '简体中文',
      device: ''
    }
  },

  mounted() {
    this.showBack = this.$route.query.showBack
    this.token = localStorage.getItem('token')
    this.language = localStorage.getItem('language')
    if (this.$route.query.token){
      this.token = this.$route.query.token
    }
    this.device = this.$util.isAndroid()
    console.log(this.device)
    console.log(this.token)
    // this.clickFullscreen()
  },

  methods: {
    clickFullscreen() {
      if (!screenfull.isEnabled) {
        this.$message.error('you browser can not work')
        this.$message({
          message: "you browser can not work",
          type: "warning"
        });
        return false;
      }
      screenfull.toggle();
    },

    // download_android() {
    //   let a = document.createElement('a')
    //   a.href = "https://felton-oss.oss-cn-beijing.aliyuncs.com/file/download/felton-app.apk"
    //   a.click();
    // },
    //
    // download_ios(){
    //   window.open('https://testflight.apple.com/join/yIUwdxMU')
    //   // let a = document.createElement('a')
    //   // a.href = 'https://testflight.apple.com/join/yIUwdxMU'
    //   // a.click();
    // },

    gotoLastPage(){
      if (window.sessionStorage.firstUrl === window.location.href) {
        this.$router.push({ path: '/' })
        return false
      } else {
        this.$router.go(-1)
      }
    },
    goBack(){
      this.$router.back()
    },

    downloadAndroid(){
      const link = document.createElement("a"); //自己创建的a标签
      link.href = download.download_android_address();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      // window.URL.revokeObjectURL(res.data);
    },
    downloadIos(){
      const link = document.createElement("a"); //自己创建的a标签
      link.href = download.download_ios_address();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      // window.URL.revokeObjectURL(res.data);
    },

    downloadsiOS(num){
      var url = download.download_ios_h5_address()
      if (num == 1) {
        url = download.download_ios_h5_address()
      } else if(num == 2) {
        url = download.download_ios_beta_address()
      } else {
        url = download.download_ios_p_address()
      }
      const link = document.createElement("a"); //自己创建的a标签
      link.href = url;
      link.target='_blank'
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    downloadPlatform(){
      const link = document.createElement("a"); //自己创建的a标签
      link.href = download.download_android_address();
      link.target='_blank'
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      // window.URL.revokeObjectURL(res.data);
    },
  }

}
</script>

<style scoped>

.down_page_mb {
  width: 375px;
}
.down_page_mb_and {
  width: 375px;
}

.down_page_mb_no {
  width: 100%;
}
.down_page_mb_and_no {
  width: 100%;
}
.pc_bg{
  background-image: url(../../assets/img/download/download_pc_bg.png);
  background-size: 100% 100%;
  /* background-size: cover; */
  /* background-repeat: round; */
  /* background-attachment: fixed; */
  background-position: center;
  width: 100%;
  height: 100%;
  min-width: 1440px;
}
@media screen and (min-width: 1500px){
  .down_content{
    left: 20%;
  }
}
@media screen and (max-width: 1500px){
  .down_content{
    left: 10%;
  }
}
@media screen and (max-width: 428px){
  .down_page_mb {
    width: 84%;
  }

  .down_page_mb_no {
    width: 90%;
  }
}

@media screen and (max-width: 400px){
  .down_page_mb {
    width: 79%;
  }
  .down_page_mb_and {
    width: 90%;
  }

  .down_page_mb_no {
    width: 90%;
  }
  .down_page_mb_and_no {
    width: 90%;
  }
}

@media screen and (max-width: 360px){
  .down_page_mb {
    width: 77%;
  }
  .down_page_mb_and {
    width: 77%;
  }

  .down_page_mb_no {
    width: 77%;
  }
  .down_page_mb_and_no {
    width: 85%;
  }
}

.download_mb_bg{
  background-image: url(../../assets/img/download/download_bg_mb.png);
  background-size: cover;
}

/*@media screen and (max-height: 730px) {*/
/*  .down_page_mb {*/
/*    width: 100%;*/
/*  }*/
/*}*/

</style>
